import moment from 'moment';
import { sortObject } from '@/lib/sorter';
import * as am4core from '@amcharts/amcharts4/core';
import am4lang_en_US from '@amcharts/amcharts4/lang/en_US';
import am4lang_ja_JP from '@amcharts/amcharts4/lang/ja_JP';

export const initialize = () => {
  /*
   * Add licence
   */
  am4core.addLicense('CH226353241');
};

export const disposeAllCharts = () => {
  am4core.disposeAllCharts();
};

export const exportChart = (chart, type) => {
  chart.exporting.export(type);
};

/**
 * Change chart locale
 * @param chart
 * @param locale {string} - locale type. [en, jp]
 */
export const changeLocale = (chart, locale) => {
  switch (locale) {
    case 'en':
      chart.language.locale = am4lang_en_US;
      break;
    case 'ja':
      chart.language.locale = am4lang_ja_JP;
      break;
  }
};

export const dataFormatter = ({ data, start, end, granularity, valueKey }) => {
  switch (granularity) {
    case 'monthly':
      granularity = 'months';
      break;
    case 'daily':
      granularity = 'days';
      break;
  }

  const newData = [];
  const dateFormat = granularity === 'days' ? 'YYYY-MM-DD' : 'YYYY-MM';

  // newDataにdateを作成
  const diff = moment(end).diff(moment(start), granularity);
  for (let i = 0; i <= diff; i++) {
    const newObj = {};
    const d = moment(start)
      .add(i, granularity)
      .toDate();
    newObj['date'] = d;

    newData.push(newObj);
  }

  data.forEach(i => {
    i.date.forEach(d => {
      // Convert to timestamp
      const original = moment(d.date);

      const targetIndex = newData.findIndex(f => {
        return moment(f.date).isSame(original, granularity);
      });

      if (targetIndex === -1) {
        const date = original.format(dateFormat);
        console.log(`Error: 日付に異常があります。date:${date}`);
      } else {
        newData[targetIndex][i.id] = d[valueKey];
      }
    });
  });

  return newData;
};

export const addOthersData = (data, othersSeries) => {
  data.forEach(val => {
    let value = 0;
    for (const key in val) {
      if (othersSeries.includes(key)) {
        value += val[key];
      }
    }

    val['#others'] = value;
  });

  return data;
};

export const calcOthersTotalAmount = data => {
  let value = 0;
  data.forEach(i => {
    if (i['#others']) {
      value += i['#others'];
    }
  });

  return value;
};

/**
 * Return formatted series.
 * Calculation total amount.
 * Sort by total amount.
 * @param data
 * @param calcKey - Target key of total calculation.
 * @return {[]}
 */
export const seriesFormatter = (data, calcKey) => {
  let newData = [];

  data.forEach(i => {
    let value = 0;
    i.date.forEach(i => {
      value += i[calcKey];
    });

    newData.push({
      name: i.name,
      id: i.id,
      value: value,
    });
  });

  newData = sortObject(newData, 'value', 'desc');

  return newData;
};

export const dateFormat = (date, locale, format = 'L') => {
  const customFormats = {
    en: {
      YtoM: 'MMMM YYYY',
      YtoSec: 'MMMM Do YYYY, h:mm:ss a',
    },
    ja: {
      YtoM: 'YYYY年MM月',
      YtoSec: 'YYYY年MM月Do h:mm:ss',
    },
  };

  /**
   * currentFormat - 特定のフォーマットの場合、customFormatsを利用する。
   * @returns {string} - Format for moment.js
   */
  const currentFormat = () => {
    if (format === 'YtoM' || format === 'YtoMinute' || format === 'YtoSec') {
      return customFormats[locale][format];
    }

    return format;
  };

  if (!date) return '-';

  //if (this.utc)
  //  return moment(this.date)
  //    .utc()
  //    .format(currentFormat());

  return moment(date).format(currentFormat());
};
